//닉네임 정규식 (3자 이상 16자 이하, 영어 또는 숫자로 구성)
export const nicknameRegex = /^(?=.*[a-z0-9])[a-z0-9]{3,16}$/;
// 이메일 정규식
export const emailRegex =
  /([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
// 패스워드 정규식 (숫자, 영문자, 특수문자 8글자 이상)
export const passwordRegex =
  /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,25}$/;
